<template>
  <b-container fluid class="sign-up w-100">
    <b-row class="logo" align-v="center">
      <b-col>
        <img src="@/assets/bing8-logo.png" alt="">
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6">
        <b-card>
          <b-form-group>
            <b-form-input v-model="username" required placeholder="Nombre de Usuario"></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input v-model="email" required placeholder="Email"></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input v-model="password" required type="password" placeholder="Contraseña"></b-form-input>
          </b-form-group>
          <b-button class="w-100" @click="validateAndSignUp" :disabled="signUpActive">Crear Usuario</b-button>
          <b-alert class="username-alert" v-if="wrongInput" variant="danger" show>
            {{wrongInput}}
          </b-alert>
        </b-card>
        <router-link to="/login">
          <b-button variant="outline-light" class="w-100 go-back">Volver a Inicio de Sesión</b-button>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

 <script>
const fb = require("../firebaseConfig.js");

export default {
  name: "signUp",
  data() {
    return {
      email: "",
      password: "",
      username: "",
      wrongInput: "",
      signUpActive: false
    };
  },
  methods: {
    validateAndSignUp() {
      this.signUpActive = true;
      if (this.username.length < 3) {
        this.wrongInput = "El nombre de usuario debe tener al menos 3 caracteres";
        this.signUpActive = false;
      } else {
        fb.usersCollection.where("username", "==", this.username).get()
        .then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            this.wrongInput = "Este nombre de usuario ya existe";
            this.signUpActive = false;
          } else {
            fb.usersCollection.where("email", "==", this.email).get()
            .then((querySnapshot) => {
              if (querySnapshot.size > 0) {
                this.wrongInput = "Este Email ya está siendo utilizado";
                this.signUpActive = false;
              } else {
                this.signUp();
              }
            })
            .catch((err) => {
              console.error("Error getting email availability", err);
              this.signUpActive = false;
            });
          }
        })
        .catch((err) => {
          console.error("Error getting username availability", err);
          this.signUpActive = false;
        });
      }
    },
    signUp() {
      fb.auth()
      .createUserWithEmailAndPassword(this.email, this.password)
      .then((res) => {
        console.log(res.user)
        const newUser = {
          uid: res.user.uid,
          displayName: this.username,
          username: this.username,
          email: this.email
        }
        res.user.updateProfile({ displayName: newUser.displayName })
        .then(() => {
          fb.usersCollection.doc(newUser.uid).set(newUser)
          .then(() => {
            this.$store.commit('setCurrentUser', newUser);
            this.$router.push(this.$route.query.redirect || '/rooms-list');
          })
        })
      },
      err => {
        if (err.code == "auth/user-not-found") {
          this.wrongInput = "Usuario o contraseña incorrectos";
        } else if (err.code == "auth/invalid-email") {
          this.wrongInput = "El formato del Email es incorrecto";
        } else if (err.code == "auth/weak-password") {
          this.wrongInput = "La contraseña debe tener al menos 6 caracteres"
        } else {
          console.error(err)
          alert(err.message);
        }
        this.signUpActive = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-up {
  position: absolute;
  background-color: var(--primary);
  height: 100%;
}
.go-back {
  margin-top: 40px;
}
.logo {
  text-align: center;
  height: 20%;
  img {
    width: 40%;
    max-width: 200px;
  }
  transition: height 0.3s;
}
.username-alert {
  margin-top: 20px;
}
</style>